// extracted by mini-css-extract-plugin
export default {"listItem":"List_listItem__xDbKv","listItemLabel":"List_listItemLabel__zDUoz"};